// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1vqy4","rootSmall":"AddTileButton_rootSmall__8Pvya"};